export default {
  state: {
    aisuduActiveProductItem: null,
    aisuduPaymentTypes: [],
    aisuduRelatedBooks: [],
  },
  getters: {},
  mutations: {
    aisuduUpdateActiveProductItem(state, value) {
      state.aisuduActiveProductItem = value;
    },
    aisuduUpdatePaymentTypes(state, value) {
      state.aisuduPaymentTypes = value;
    },
    aisuduUpdateRelateBook(state, value) {
      state.aisuduRelatedBooks = value;
    }
  },
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/aisudu/aisudu.js